<script setup>
import { ref } from 'vue'
import WindowsOutlined from "@/components/icons/WindowsOutlined.vue";
import AppleOutlined from "@/components/icons/AppleOutlined.vue";
import MacosDownload from "./macos/download.vue";
import WindowsDownload from "./window/download.vue";
import {envs} from "@/main/envs";
import {Versions} from "@/main/version";

const activeTab = ref(envs.os === 'windows' ? 'windows': 'macos')
const assets = ref({});
const waited = ref(true);

Versions.getLatest().then((latest) => {
  assets.value = latest || {};
}).finally(() => {
  waited.value = false;
})

function handleTabClick(tab) {
  // 可选：处理 tab 切换逻辑
  console.log('Switched to:', tab.name)
}
</script>

<template>
  <div class="tabs-container">
    <el-tabs v-model="activeTab">
      <!-- Windows Tab -->
      <el-tab-pane name="windows">
        <template #label>
          <div class="tab-item">
            <WindowsOutlined/>
            Windows
          </div>
        </template>
        <windows-download :assets="assets['windows']"/>
      </el-tab-pane>
      <!-- macOS Tab -->
      <el-tab-pane name="macos">
        <template #label>
          <div class="tab-item">
            <AppleOutlined/>
            MacOS
          </div>
        </template>
        <macos-download :assets="assets['macos']"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<style scoped>
/* 覆盖 el-tabs 默认样式，匹配你的设计 */
:deep(.custom-el-tabs .el-tabs__header) {
  margin: 0 0 1.5rem;
  border-bottom: 1px solid var(--border);
  padding: 0;
}

:deep(.custom-el-tabs .el-tabs__nav-wrap::after) {
  display: none; /* 移除 el-tabs 底部高亮线 */
}

:deep(.custom-el-tabs .el-tabs__item) {
  padding: 0.8rem 1.5rem !important;
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-muted);
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  transition: all 0.2s;
  cursor: pointer;
}

:deep(.custom-el-tabs .el-tabs__item:hover:not(.is-active)) {
  color: var(--text-light);
  background: #f8fafc;
}

:deep(.custom-el-tabs .el-tabs__item.is-active) {
  color: var(--primary) !important;
  border-bottom: 2px solid var(--primary) !important;
}

/* 内容区保持你原有的样式 */
.platform-options {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.option-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  background: white;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  text-decoration: none;
  font-weight: 600;
  color: var(--primary);
  transition: all 0.2s;
  cursor: pointer;
}

.option-btn:hover {
  border-color: var(--primary);
  background: #f0f5ff;
}

.option-icon {
  font-size: 1.4rem;
}

.help-link {
  display: block;
  margin-top: 1.2rem;
  color: var(--text-muted);
  font-size: 0.9rem;
  text-decoration: underline;
  cursor: pointer;
}

.tab-item {
  padding-inline: 15px;
  font-size: 18px;
}
</style>
